import moment from 'moment';

/** Policy term status enum */
export enum PolicyTermStatus {
  renewal = 'RENEWAL',
  cancel = 'CANCEL',
  expire = 'EXPIRE'
}

/**
 * Marks whether the policy term is valid to display.
 * If the policy has multiple terms, it checks if the policy billing effective date matches the term effective date.
 * @param policy The policy item
 */
export function markPolicyValidTerm(policy: any): any {
  // UAT #47761 : Solution - Verify if policy.billingEffectiveDate and terms.billing.effectiveDate are same or not
  if (policy.terms.length > 1) {
    policy.terms.forEach((term: any) => {
      if (term.status !== PolicyTermStatus.renewal && moment(new Date(policy.billingEffectiveDate)).isSame(new Date(term.effectiveDate))) {
        term['validTerm'] = true; // Additional field added NOT coming from service
      } else {
        term['validTerm'] = false;
      }
    });
  } else {
    policy.terms[0]['validTerm'] = true;
  }
}